import React from "react";
import ChartImage from "../../../../assets/images/CHPT/chart.png";

import CardsImage from "../../../../assets/images/CHPT/chartyParty.png";
import chptLogo from "../../../../assets/images/charty-party/chpt-logo.png";

import { compose } from "redux";
import { withSocket } from "../../../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

const Chart = (props) => {
  let roomData = _.get(props, "gameReducer.roomObj");
  const prompt = _.get(roomData, "game_state.prompt");
  let gameData = _.get(props, "paramsReducer");
  let status = _.get(roomData, "game_state.status");
  const playedCards = _.get(roomData, "game_state.played_cards");
  return (
    <div className="d-flex justify-content-between align-items-center">
      {status === "Playing" && playedCards.length === 0 ? (
        <div className="playing-cards-wrap">
          <div className="empty-box">Empty</div>
        </div>
      ) : (
        <>
          {status === "Playing" && playedCards.length > 0 ? (
            <div className="playing-cards-wrap">
              <div className="playing-cards-image">
                {playedCards.map((item) => {
                  return <img src={CardsImage} />;
                })}
              </div>
            </div>
          ) : null}
        </>
      )}
      {/*<img src={CardsImage} />
        <img src={CardsImage} />
        <img src={CardsImage} />
      </div> */}
      {/* </div> */}

      {status === "PrePlay" && (
        <div className="chart-image">
          <img src={chptLogo} at="" className="chpt-logo" />
        </div>
      )}
      {status === "Playing" && (
        <div className="chart-image">
          <img src={prompt.url} at="" />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(Chart);
